import {
  PlusOutlined,
  ArrowRightOutlined,
  PlusCircleFilled,
  StarFilled,
} from '@ant-design/icons';
import { ButtonSize } from 'enums/ButtonEnums';
import React from 'react';
import COButton from 'shared/components/COButton';
import CODropdownButton from 'shared/components/CODropdownButton';
import COIconButton from 'shared/components/COIconButton';

const ButtonAppComponent = () => {
  return (
    <>
      <h2>Buttons</h2>
      <div style={{ width: '12.5%', gap: '10px' }}>
        <COButton onClick={() => alert('clicked')}>Medium</COButton>
        <COButton secondary>Medium</COButton>
      </div>

      <div className="mt-1 flex-inline flex-wrap" style={{ width: '30%' }}>
        <div style={{ width: '200px' }}>
          <COButton>Button</COButton>
        </div>
        <div style={{ width: '200px' }}>
          <COButton>Button</COButton>
        </div>
        <div style={{ width: '200px' }}>
          <COButton disabled>Button</COButton>
        </div>
        <div style={{ width: '200px' }}>
          <COButton secondary>Save as draft</COButton>
        </div>
        <div style={{ width: '200px' }}>
          <COButton secondary disabled>
            Secondary
          </COButton>
        </div>
        <div style={{ width: '200px' }}>
          <COButton secondary icon={<PlusOutlined />}>
            Button
          </COButton>
        </div>
        <COButton>
          Next
          <ArrowRightOutlined />
        </COButton>
        <COButton icon={<PlusOutlined />}>Button</COButton>

        <div style={{ width: '200px' }}>
          <COButton text icon={<PlusCircleFilled />}>
            Product Distribution
          </COButton>
        </div>
        <div style={{ width: '200px' }}>
          <COButton>Confirm</COButton>
        </div>
        <COButton secondary>Cancel</COButton>
        <COButton text>Confirm</COButton>
        <COButton text disabled>
          Cancel
        </COButton>
      </div>

      <div className="ml-2 flex-inline"></div>
      <div className="flex-inline"></div>
      <div className="mt-5">
        <h2>Icon Buttons</h2>
        <div className="mt-2 flex-inline ">
          <COIconButton secondary icon={<StarFilled />} />
          <COIconButton size={ButtonSize.MEDIUM} icon={<StarFilled />} />
          <COIconButton size={ButtonSize.MEDIUM} icon={<StarFilled />} />
          <COIconButton
            size={ButtonSize.MEDIUM}
            icon={<StarFilled />}
            disabled
          />
          <COIconButton secondary icon={<StarFilled />} disabled />
        </div>
      </div>
      <div
        className="ml-2 "
        style={{
          gap: '10px',
          display: 'flex',
          alignItems: 'center',
        }}>
        <h2>Button Dropdown</h2>
        <CODropdownButton
          items={[
            {
              value: 'Agriculture Commodity',
              icon: <StarFilled />,
              onClick: () => alert('clicked'),
            },
            {
              value: 'Live Stock Commodity',
              icon: <PlusCircleFilled />,
              onClick: () => alert('clicked'),
              disabled: true,
            },
          ]}>
          New Commodity
        </CODropdownButton>
      </div>
    </>
  );
};

export default ButtonAppComponent;
